/**
 * The pages a GUEST may open in the community edition, by app path (the base
 * path already stripped). Explore, a Public collection's page by id (the page
 * itself decides what a guest gets), a share link, the sign-in and sign-up
 * entries (decided 2026-09-09), and `/` — which sends a guest on to Explore
 * (community/pages/RootRoute.tsx). Without `/` here the boot gate in main.tsx
 * sends a stranger to /signin before the router ever runs, so the front door of
 * tileriver.com was a sign-in form.
 */
export function isGuestPath(p: string): boolean {
  return (
    p === '/' ||
    p === '' ||
    p === '/explore' ||
    p.startsWith('/explore/') ||
    /^\/collections\/col_[0-9a-f]{12}$/.test(p) ||
    // A share link, and the study and slide inside it (community/share).
    /^\/s\/(col|stu)\/[0-9A-Za-z]{16}(\/[0-9A-Za-z]{6}){0,2}$/.test(p) ||
    ['/signin', '/signup', '/forgot', '/verify', '/reset', '/setup', '/invite'].includes(p)
  );
}

/**
 * Where a GUEST who arrives at `/` with a `?return=` should go instead of Explore.
 *
 * `/` is open to guests (it sends them on to Explore), but it is also where the
 * operator dashboard bounces a 401: `/?return=/dashboard/`. Letting that through
 * dropped an operator whose session had expired — or anyone opening /admin
 * signed out — on Explore with no sign-in and no way back. A return path means
 * someone wants to sign in and come back, so that visit is a sign-in.
 * `back` must already be vetted (safeReturnPath); null means no usable return.
 */
export function guestReturnSignIn(p: string, back: string | null): string | null {
  return (p === '/' || p === '') && back ? back : null;
}
